import OfficeSelect from "../../design/OfficeSelect";
import { useState, useEffect } from "react";
import { fetchSaveWorkers } from "../../../faetures/fetchSave";


function OfficeAndWorkers({ officeValue, setOfficeValue, workValue, setWorkValue, workers }) {
    const [data, setData] = useState({}); // data contains json - {office number: workers}
    const Admin = sessionStorage.getItem('admin') === 'admin';

    useEffect(() => {
        async function fetchData() {
            try {
                const resolve = await fetchSaveWorkers();
                setData(resolve);
            } catch {
                setData({});
            }
        }

        fetchData();
    }, [])

    return (<>
        <p>משרד</p>

        <OfficeSelect
            value={officeValue}
            setValue={setOfficeValue}
        />

        <p>עובד</p>

        {workers ? ( 
            <select value={workValue} onChange={(e) => setWorkValue(e.target.value)}>
                <option value={"*"}>הכל</option>
                {workers.map((worker, index) => (
                    <option key={index} value={worker}>
                        {worker}
                    </option>
                ))}
            </select>) : (<select value={workValue} onChange={(e) => setWorkValue(e.target.value)}>
                <option value={"*"}>הכל</option>

                {
                    Object.values(Admin ? officeValue in data ? data[officeValue] : {} : data).map((value, key) => (
                        <option key={key} value={value}> {value} </option>
                    ))
                }


            </select>)}

    </>)
}


export default OfficeAndWorkers;